import { Component,
         Input,
         Output,
         EventEmitter }                    from '@angular/core';

@Component({
  selector: 'sa-file-upload',
  template: require('./file-upload.html'),
  styles: ['./file-upload.scss']
})
export class FileUploadComponent {

  @Input() showFileName = true;

  @Output() fileUploaded = new EventEmitter();

  public model: any = {
    newFileName: null
  };

  public inputClick(fileElem) {
    fileElem.click();
  }

  public fileChanged(event) {
    let files = event.currentTarget.files;
    if (files[0]) {
      this.model.newFileName = files[0].name;
      this.fileUploaded.emit(files[0]);
    } else {
      this.model.newFileName = null;
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/common/file-upload.component.ts